const HEADER_TABS = [
  {
    title: "about",
    listTitle: "Discover the people and passion behind TRooTech",
    blogTitle: "Insights",
  },
  {
    title: "technologies",
    listTitle: "All your technology needs solved under one roof",
    blogTitle: "Insights",
  },
  {
    title: "hire developers",
    listTitle:
      "Fully flexible on-demand software development teams for your projects",
    blogTitle: "Insights",
  },
  {
    title: "services",
    listTitle:
      "Transformative Digital Solutions: Custom Software Development, Enterprise Technology, and Industry-Specific Innovations",
    blogTitle: "Insights",
  },
  {
    title: "industries",
    listTitle:
      "Empowering Industries with Digital Excellence & Niche Expertise",
    blogTitle: "Insights",
  },
  {
    title: "startup",
    listTitle: "Startup domains we support",
    blogTitle: "Insights",
  },
  {
    title: "resources",
    listTitle: "Our research in development",
    blogTitle: "Insights",
  },
];

const SOCIAL_MEDIA_FOOTER_DATA = {
  "linked in": {
    name: "linkdin",
    imgUrl: "/images/foot-linkdin.svg",
  },
  instagram: {
    name: "instagarm",
    imgUrl: "/images/foot-instagarm.svg",
  },
  twitter: {
    name: "twiter",
    imgUrl: "/images/foot-twiter.svg",
  },
};

const IMAGE_TYPE = [
  "image/bmp",
  "image/png",
  "image/jpg",
  "image/jpeg",
  "application/pdf",
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

const CATEGORIES = [
  "DevOps",
  "Software",
  "Salesforce",
  "Cloud",
  "Custom Software Solutions",
  "Software Modernization",
  "Digital Transformation",
  "Mobile App",
  "Python",
  "GenAI",
  "Software Development",
  "AI",
  "Emerging Technologies",
  "Website",
  "Data Science",
  "SaaS",
  "CRM",
];

const serviceTypeOptions = [
  {
    value: "AI Consulting",
    label: "AI Consulting",
  },
  {
    value: "Generative AI",
    label: "Generative AI",
  },
  {
    value: "Agentic AI",
    label: "Agentic AI",
  },
  {
    value: "Predictive Analytics",
    label: "Predictive Analytics",
  },
  {
    value: "Computer Vision",
    label: "Computer Vision",
  },
  {
    value:
      "Salesforce: Consulting, Implementation, Development, and Maintenance",
    label:
      "Salesforce: Consulting, Implementation, Development, and Maintenance",
  },
  {
    value: "HubSpot: Consulting, Implementation, Development, and Maintenance",
    label: "HubSpot: Consulting, Implementation, Development, and Maintenance",
  },
  {
    value:
      "ServiceNow: Consulting, Implementation, Development, and Maintenance",
    label:
      "ServiceNow: Consulting, Implementation, Development, and Maintenance",
  },
  {
    value: "SAP: Consulting, Implementation, Development, and Maintenance",
    label: "SAP: Consulting, Implementation, Development, and Maintenance",
  },
  {
    value:
      "MS Dynamics 365: Consulting, Implementation, Development, and Maintenance",
    label:
      "MS Dynamics 365: Consulting, Implementation, Development, and Maintenance",
  },
  {
    value: "Workday: Consulting, Implementation, Development, and Maintenance",
    label: "Workday: Consulting, Implementation, Development, and Maintenance",
  },
  {
    value: "Odoo: Consulting, Implementation, Development, and Maintenance",
    label: "Odoo: Consulting, Implementation, Development, and Maintenance",
  },
  {
    value: "Custom Software Development ",
    label: "Custom Software Development ",
  },
  {
    value: "Mobile App Development ",
    label: "Mobile App Development ",
  },
  {
    value: "Application Modernization ",
    label: "Application Modernization ",
  },
  {
    value: "Cloud Engineering ",
    label: "Cloud Engineering ",
  },
  {
    value: "Product Design",
    label: "Product Design",
  },
  {
    value: "Data Engineering ",
    label: "Data Engineering ",
  },
  {
    value: "Not Sure",
    label: "Not Sure",
  },
];


export {
  HEADER_TABS,
  SOCIAL_MEDIA_FOOTER_DATA,
  IMAGE_TYPE,
  CATEGORIES,
  serviceTypeOptions,
};
